import { useEffect, useRef, useState } from "react";

export function useSpeech(onFinal, enabled, onInterim) {
  const cbRef = useRef(onFinal);
  cbRef.current = onFinal;
  const interimCbRef = useRef(onInterim);
  interimCbRef.current = onInterim;
  const [supported] = useState(
    () => !!(window.SpeechRecognition || window.webkitSpeechRecognition)
  );
  const [interim, setInterim] = useState("");

  useEffect(() => {
    if (!enabled || !supported) {
      setInterim("");
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    let stopped = false;
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = "en-US";
    rec.onresult = (e) => {
      let fin = "";
      let inter = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const t = e.results[i][0].transcript;
        if (e.results[i].isFinal) fin += t;
        else inter += t;
      }
      setInterim(inter);
      if (inter.trim() && interimCbRef.current) interimCbRef.current(inter.trim());
      if (fin.trim()) cbRef.current(fin.trim());
    };
    rec.onend = () => {
      if (!stopped) {
        try { rec.start(); } catch (_) {}
      }
    };
    rec.onerror = () => {};
    try { rec.start(); } catch (_) {}
    return () => {
      stopped = true;
      try { rec.stop(); } catch (_) {}
      setInterim("");
    };
  }, [enabled, supported]);

  return { supported, interim };
}
